var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinutes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "parent",
    d: "M12 21.9999C16.7883 21.9999 20.67 18.1182 20.67 13.3299C20.67 8.5416 16.7883 4.65991 12 4.65991C7.21168 4.65991 3.32999 8.5416 3.32999 13.3299C3.32999 18.1182 7.21168 21.9999 12 21.9999Z",
    fill: "#F22B5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    d: "M12 13.75C11.59 13.75 11.25 13.41 11.25 13V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V13C12.75 13.41 12.41 13.75 12 13.75Z",
    fill: "#594AD7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "secondary",
    d: "M14.89 3.45H9.11001C8.71001 3.45 8.39001 3.13 8.39001 2.73C8.39001 2.33 8.71001 2 9.11001 2H14.89C15.29 2 15.61 2.32 15.61 2.72C15.61 3.12 15.29 3.45 14.89 3.45Z",
    fill: "#594AD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinutes);
export default __webpack_public_path__ + "static/media/minutes.97c87972f3df4dba794f7a1b9f90cfaf.svg";
export { ForwardRef as ReactComponent };